import React from 'react';

// Import cùng file ảnh logo QLTM đó
import logoQltm from 'assets/images/logo-qltm.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    <img 
      src={logoQltm} 
      alt="QLTM Icon" 
      width="45"
      style={{ 
        display: 'block',
        objectFit: 'contain'
      }} 
    />
  );
}